import ReactPaginate from "react-paginate";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout } from '../redux/controller';
import 'react-toastify/dist/ReactToastify.css';
import { FaMoneyCheckAlt } from "react-icons/fa";

export default function LandownersDetails() {

  const selectedSeason = useSelector((state) => state.season.selectedSeason);
  const location = useLocation();
  const { state } = location;
  const { id, Landowner, email, phone_number, createdAt, affiliateTotalEarnings, affiliateCommissionPercentage } = state || {};


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setperPage] = useState(10);
  const [commissions, setCommissions] = useState(0);
  const [isCommissionLoading, setCommisionLoading] = useState(true);
  const [landownerId, setLandownerId] = useState("");
  const [landownerName, setLandownerName] = useState("");
  const [landownerEmail, setLandownerEmail] = useState("");
  const [landownerPhone, setLandownerPhone] = useState("");
  const [landownerCreatedAt, setLandownerCreatedAt] = useState("");
  const [paymentHisotryData, setPaymentHisotryData] = useState([]);

  const [loadingDetails, setLoadingDetails] = useState(true);

  const [totalEarnings, setTotalEarnings] = useState(0);
  const [currentSeasonReservationsCount, setCurrentSeasonsReservationsCount] = useState(0);

  const [searchInput, setSearchInput] = useState("");

  const [landownerCommision, setLandownerCommision] = useState('');
  const [affiliateCommissionPercent, setAffiliateCommissionPercent] = useState(5);

  const [landownersdata, setPropertyData] = useState([]);

  const [reservationsData, setReservationsData] = useState([]);
  const [reservationsLoading, setReservationsLoading] = useState(true);
  const [reservationsCurrentPage, setReservationsCurrentPage] = useState(0);
  const [reservationsPerPage, setReservationsPerPage] = useState(10);

  const usertoken = localStorage.getItem('usertoken');

  const effectRan = useRef(false);

  function inputperPage(e) {
    setperPage(Number(e.target.value));
    setCurrentPage(0);
  }

  const getLandownerPropertiesReservations = async () => {
    setReservationsLoading(true);
    var response = await dispatch(
      fetchData({
        apiurl: "/reservation/landownerpropertiesreservations",
        landownerId: id ?? landownerId,
        headers: { "x-access-token": usertoken },
      })
    );
    setReservationsLoading(false);
    if (response.payload && response.payload.reservations) {
      setReservationsData(response.payload.reservations);
    }
  };

  useEffect(() => {
    if (id) {
      setLandownerId(id)
      setLandownerName(Landowner)
      setLandownerEmail(email)
      setLandownerPhone(phone_number)
      setLandownerCreatedAt(createdAt)
      setAffiliateCommissionPercent(affiliateCommissionPercentage ?? 5)
      getAllHunters();
      getPaymentHisotry();
      getLandownerPropertiesReservations();
    } else {
      navigate("/")
    }
  }, [dispatch, usertoken, navigate, selectedSeason]);

  function convertdate(date) {
    return date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4)
  }

  const getPaymentHisotry = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/auth/user/payment-history",
        userId: id ?? landownerId,
        headers: { "x-access-token": usertoken },
      })
    );

    if (response.payload && response.payload.payment_history && response.payload.payment_history.length > 0) {
      setPaymentHisotryData(response.payload.payment_history)
    }
  };



  const getAllHunters = async (searchQuery = "") => {
    if (selectedSeason && selectedSeason.seasonEndDate && selectedSeason.seasonStartDate) {
      setPropertyData([]);
      setStatus('Loading...')
      var reservationList = await dispatch(
        fetchData({
          apiurl: "/property/listAllproperty",
          page: 1,
          id: id ?? landownerId,
          limit: 10000,
          search: searchQuery,
          seasonEndDate: selectedSeason.seasonEndDate,
          seasonStartDate: selectedSeason.seasonStartDate,
          headers: { "x-access-token": usertoken }
        })
      );
      setLoadingDetails(false)

      if (reservationList && reservationList.payload && reservationList.payload.status === 200) {
        if (reservationList.payload.data && reservationList.payload.data.length) {
          const propertyListTest = [];

          let currentSeasonResCount = 0;
          let tEarings = 0;
          for (let i = 0; i < reservationList.payload.data.length; i++) {
            const element = reservationList.payload.data[i];
            currentSeasonResCount = currentSeasonResCount + element.currentSeasonReservations;
            tEarings = tEarings + element.propertyEarnings;
            let totalArea = 0;
            let totalSlots = 0;
            if (element.property.area != null) {
              if (element.property.area.length > 0) {
                for (let j = 0; j < element.property.area.length; j++) {
                  totalArea = totalArea + 1;
                  totalSlots = totalSlots + element.property.area[j].slots.length;

                }
              }
            }
            const data = {
              category: element.property.category,
              county: element.property.country,
              city: element.property.city,
              stateLocal: element.property.state,
              zipcode: element.property.zipcode,
              totalarea: element.property.totalarea,
              property: element.property,
              totalArea: totalArea,
              totalSlots: totalSlots,
              id: element.property._id,
              property_name: element.property.title,
              no_of_booking: element.reservationsCount,
              propertyEarnings: element.propertyEarnings,
            };
            propertyListTest.push(data);
          }

          setTotalEarnings(tEarings)
          setCurrentSeasonsReservationsCount(currentSeasonResCount);

          setPropertyData(propertyListTest);
        } else {
          setStatus('No properties!')
        }
        setCommisionLoading(false)
      } else {
        if (reservationList.payload.response && reservationList.payload.response.data && reservationList.payload.response.data.message) {
          if (reservationList.payload.response.data.message === "Invalid token provided!" || reservationList.payload.response.data.message === "No token provided!") {
            // toastify({ message: 'Session expired' });
            userlogout();
            navigate('/');
          }
        }
      }
    }
  }

  const handleSearch = () => {
    getAllHunters(searchInput);
  };

  const handleClearSearch = () => {
    setSearchInput("");
    getAllHunters();
  };


  const handlereservationupcomingidPageClick = (selectedPage) => {
    setReservationupcomingidcurrentPage(selectedPage.selected);
  };

  const [status, setStatus] = useState('Loading...');

  // Calculate start and end index for the current page
  const [
    reservationupcomingidcurrentPage,
    setReservationupcomingidcurrentPage
  ] = useState(0);
  const reservationupcomingidperPage = 10;
  const reservationupcomingidstartIndex =
    reservationupcomingidcurrentPage * reservationupcomingidperPage;
  const reservationupcomingidendIndex =
    reservationupcomingidstartIndex + reservationupcomingidperPage;

  // Get data for the current page
  const reservationupcomingidcurrentData = landownersdata.slice(
    reservationupcomingidstartIndex,
    reservationupcomingidendIndex
  );

  const handleCommissionsChange = (value) => {
    setLandownerCommision(value);
  };


  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      var settingsData = await dispatch(
        fetchData({
          apiurl: "/settings/getlandownercommission",
          landownerId: id ?? landownerId,
          headers: { "x-access-token": usertoken }
        })
      );

      if (settingsData && settingsData.payload && settingsData.payload.landownerCommission) {
        setLandownerCommision(settingsData.payload.landownerCommission.landownerCommision);
      } else {
        handleSettings()
      }
    } catch (error) {
      handleSettings()
    }

  };



  const handleSave = async () => {


    const value = parseFloat(landownerCommision);

    if (!value && value !== 0) {
      toastify({ message: "Please enter a commission" });
      return;
    }

    if (value > 100) {
      toastify({ message: "Commission cannot be greater than 100%" });
      return;
    }

    // Proceed if validation passes
    console.log("Commission to save:", value);
    // ... your save logic

    var savedSettings = await dispatch(
      fetchData({
        apiurl: "/settings/savelandownerscommisions",
        landownerCommision: parseFloat(landownerCommision) || 0,
        landownerId: id ?? landownerId,
        headers: { "x-access-token": usertoken }
      })
    );

    if (savedSettings && savedSettings.payload && savedSettings.payload.message) {
      toastify({ message: savedSettings.payload.message });
    } else {
      toastify({ message: savedSettings.payload.message });
    }
  };




  const handleSettings = async () => {
    var settingsData = await dispatch(
      fetchData({
        apiurl: "/settings/getsettings",
        headers: { "x-access-token": usertoken }
      })
    );

    if (settingsData && settingsData.payload && settingsData.payload.setting) {
      setLandownerCommision(settingsData.payload.setting.landownersCommisions)
    }
  };


  const pageCount = Math.ceil(paymentHisotryData.length / perPage);

  const offset = currentPage * perPage;
  const currentPageData = paymentHisotryData.slice(offset, offset + perPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const reservationsPageCount = Math.ceil(reservationsData.length / reservationsPerPage);

  const reservationsOffset = reservationsCurrentPage * reservationsPerPage;
  const reservationsCurrentPageData = reservationsData.slice(reservationsOffset, reservationsOffset + reservationsPerPage);

  const handleReservationsPageChange = ({ selected }) => {
    setReservationsCurrentPage(selected);
  };

  const handleReservationsPerPageChange = (e) => {
    setReservationsPerPage(Number(e.target.value));
    setReservationsCurrentPage(0);
  };

  return (
    <div className="landowner-ditailsdiv">
      <div className="reservation-idtable">

        <div className="search-div landowner_header_main">
          <div className="landowner_header_save">

          </div>
          <div className="landowner_header_save">
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control hunter-search"
                placeholder="Landowner Name, Property Name"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              {searchInput && (
                <button className="clear-btn" onClick={handleClearSearch}>
                  ×
                </button>
              )}
            </div>
            <button className="add-btn" onClick={handleSearch}>
              Search
            </button>
          </div>
        </div>
        <div className="reservation_divider details_section">
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Name</h1>
              <p>{landownerName}</p>
            </div>
          </div>
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Email ID</h1>
              <p>{landownerEmail}</p>
            </div>
          </div>
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Phone Number</h1>
              <p>{landownerPhone}</p>
            </div>
          </div>
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Account Created</h1>
              {/* <p>{`${new Date(landownerCreatedAt).toLocaleDateString()}`}</p> */}
              <p>
                {/* {new Date(landownerCreatedAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  })} */}
                {convertdate(landownerCreatedAt)}
              </p>
            </div>
          </div>
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Earnings</h1>
              <p>{loadingDetails ? <span className="loading-dots">.</span> : `$${totalEarnings}`}</p>
            </div>
          </div>
          <div className="reservation_part">
            <div className="reservation_content">
              <h1>Affiliate Earnings</h1>
              <p>${(affiliateTotalEarnings ?? 0).toLocaleString()}</p>
            </div>
          </div>
        </div>
        <div className="vpk">
          <div className="add-formdiv-pro Property details_inner_section commission_settings">
            <div className="add-main">
              <div className="add-formdiv">
                <div className="add-top">
                  <div className="slot-datetable">
                    <div className="slot-datetable1">
                      <h2>Commission Settings</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-form">
              <div className="select-div commission-settings-grid">
                
                {/* Default Landowner Commission */}
                <div className="select-div1 commission-column">
                  <label
                    htmlFor="exampleInputEmail1"
                    className="form-label required"
                  >
                    Default Landowner Commission (%):
                  </label>
                  <div className="commission-row-content">
                    <div className="hunder_inner_div">
                      <input
                        type="number"
                        className="form-control hunter-search"
                        placeholder="Enter Landowner Commission"
                        value={landownerCommision}
                        disabled={isCommissionLoading ? true : currentSeasonReservationsCount > 0}
                        onChange={(e) => handleCommissionsChange(e.target.value)}
                      />
                      <button 
                        className={`add-btn ${isCommissionLoading || currentSeasonReservationsCount > 0 ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={isCommissionLoading ? true : currentSeasonReservationsCount > 0}
                      >
                        Save
                      </button>
                    </div>
                    <div className="info-div-for-commission">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z" fill="#be7637"></path> 
                          <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z" fill="#be7637"></path> 
                          <path fillRule="evenodd" clipRule="evenodd" d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" fill="#be7637"></path> 
                        </g>
                      </svg>
                      <span>
                        Set the commission for this landowner.<br /> 
                        <i><b>Note:</b> Once a reservation is made in the current season, the commission cannot be modified.</i>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Affiliate Commission */}
                <div className="select-div1 commission-column">
                  <label className="form-label">
                    Affiliate Commission (%):
                  </label>
                  <div className="commission-row-content">
                    <div className="hunder_inner_div no-button">
                      <input
                        type="number"
                        className="form-control hunter-search"
                        value={affiliateCommissionPercent}
                        disabled={true}
                      />
                    </div>
                    <div className="info-div-for-commission">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z" fill="#be7637"></path> 
                          <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z" fill="#be7637"></path> 
                          <path fillRule="evenodd" clipRule="evenodd" d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" fill="#be7637"></path> 
                        </g>
                      </svg>
                      <span>
                        This is the affiliate commission percentage for this landowner.<br /> 
                        <i><b>Note:</b> This commission is configured during the signup process and serves as the default commission rate defined by the admin in the Settings tab.</i>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div className="vpk payout-history">
          <div className="add-formdiv-pro Property details_inner_section commission_settings">
            <div className="add-main">
              <div className="add-formdiv">
                <div className="add-top">
                  <div className="slot-datetable">
                    <div className="slot-datetable1">
                      <h2>Payout History</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-form earninglist-table">
              <div className="add-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Transaction ID</th>
                      <th scope="col">Payment Status (Paid / Pending)</th>
                      <th scope="col">Paid Amount</th>
                      <th scope="col">Credited Date</th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      display:
                        paymentHisotryData &&
                          paymentHisotryData.length
                          ? "contents"
                          : "table-caption",
                    }}
                  >

                    {currentPageData.length ? (
                      currentPageData.map((reservation, index) => (
                        <tr key={index}>
                          <td>{reservation.transactionId}</td>
                          <td>{reservation.status == 'Done' ? 'Paid' : 'Pending'}</td>
                          <td>${reservation.amount}</td>
                          <td>{convertdate(reservation.date)}</td>
                        </tr>
                      ))
                    ) : (

                      <div className="header-empty">
                        No payment history found
                      </div>

                    )}
                  </tbody>
                </table>
              </div>

              {paymentHisotryData.length ? (
                <div className="rowperpage">
                  <div className="perpagecount">
                    Rows Per Page&nbsp;
                    <select onChange={inputperPage} value={perPage}>
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={150}>150</option>
                      <option value={200}>200</option>
                    </select>
                  </div>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={perPage}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination custom-pagination"}
                    activeClassName={"active"}
                  // forcePage={currentPage}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="vpk property-listing">
          <div className="add-formdiv-pro Property details_inner_section commission_settings">
            <div className="add-main">
              <div className="add-formdiv">
                <div className="add-top">
                  <div className="slot-datetable">
                    <div className="slot-datetable1">
                      <h2>Property Listing</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-form pagination-table">
              <div className="add-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Property Name</th>
                      <th>Number of Area</th>
                      <th>Number of Slots</th>
                      <th>Number of Booking</th>
                      <th>Property Earnings</th>
                    </tr>
                  </thead>
                  <tbody style={{
                    display:
                      reservationupcomingidcurrentData &&
                        reservationupcomingidcurrentData.length
                        ? "contents"
                        : "table-caption",
                  }}>
                    {reservationupcomingidcurrentData.length === 0 ?
                      <div className="header-empty p21">
                        {status}
                      </div>
                      :
                      reservationupcomingidcurrentData.map((reservation) => (
                        <tr key={reservation.id} className="upcoming_cancel">
                          {/* <td><Link className="hunter-link" to={`/propertydetails`} state={reservation} >{reservation.property_name}</Link></td> */}
                          <td>{reservation.property_name}</td>
                          <td>{reservation.totalArea}</td>
                          <td>{reservation.totalSlots}</td>
                          <td>{reservation.no_of_booking}</td>
                          <td>${reservation.propertyEarnings}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <ReactPaginate
                pageCount={Math.ceil(
                  landownersdata.length / reservationupcomingidperPage
                )}
                pageRangeDisplayed={10}
                breakLabel={"..."}
                marginPagesDisplayed={2}
                onPageChange={handlereservationupcomingidPageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>

          </div>
        </div>

        <div className="vpk property-listing" style={{ marginTop: '30px' }}>
          <div className="add-formdiv-pro Property details_inner_section commission_settings">
            <div className="add-main">
              <div className="add-formdiv">
                <div className="add-top">
                  <div className="slot-datetable">
                    <div className="slot-datetable1">
                      <h2>Properties Reservations</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-form pagination-table">
              <div className="add-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Hunter Name</th>
                      <th>Hunter Phone No.</th>
                      <th>Hunter Email</th>
                      <th>Property Name</th>
                      <th>Purchase Date</th>
                      <th>Reservation Date</th>
                      <th>Slot ID</th>
                      <th>Cost</th>
                      <th>Payment ID</th>
                      <th>Reservation Status</th>
                    </tr>
                  </thead>
                  <tbody style={{
                    display:
                      reservationsCurrentPageData &&
                        reservationsCurrentPageData.length
                        ? "contents"
                        : "table-caption",
                  }}>
                    {reservationsLoading ? (
                      <div className="header-empty p21">
                        Loading...
                      </div>
                    ) : reservationsCurrentPageData.length === 0 ? (
                      <div className="header-empty p21">
                        No reservations found!
                      </div>
                    ) : (
                      reservationsCurrentPageData.map((item, index) => {
                        const reservation = item.reservations;
                        const hunter = item.hunter;
                        const hunterName = hunter ? `${hunter.firstname || ""} ${hunter.lastname || ""}`.trim() || "--" : "--";
                        const hunterPhone = hunter ? hunter.phonenumber || "--" : "--";
                        const hunterEmail = hunter ? hunter.email || "--" : "--";
                        const propertyName = reservation.cart && reservation.cart[0] && reservation.cart[0].property ? reservation.cart[0].property.title : "--";
                        const purchaseDate = reservation.createdAt ? convertdate(reservation.createdAt) : "--";
                        const cost = reservation.paymentdetail ? reservation.paymentdetail.total || "0" : "0";
                        const paymentId = reservation.payment && reservation.payment.paymentdata ? reservation.payment.paymentdata.paymenttId || "--" : "--";
                        const status = reservation.orderstatus === "cancelled" ? "Cancelled" : reservation.orderstatus === "pending" ? "Pending" : "Booked";

                        return (
                          <tr key={reservation._id || index} className={`upcoming_cancel ${
                            status === "Cancelled"
                              ? "Action_Reservation_Cancelled"
                              : status === "Pending"
                              ? "Action_Reservation_Pending"
                              : "Action_Reservation_Booked"
                          }`}>
                            <td>{hunterName}</td>
                            <td>{hunterPhone}</td>
                            <td>{hunterEmail}</td>
                            <td>{propertyName}</td>
                            <td>{purchaseDate}</td>
                            <td>
                              {reservation.cart && reservation.cart.map((cartItem, idx) => (
                                <p key={idx}>{convertdate(cartItem.selecteddate)}</p>
                              ))}
                            </td>
                            <td>
                              {reservation.cart && reservation.cart.map((cartItem, idx) => (
                                <p key={idx}>{cartItem.selectedslot?.name || "--"}</p>
                              ))}
                            </td>
                            <td>${cost}</td>
                            <td>{paymentId}</td>
                            <td>
                              <button
                                className="reservation-actionbtn"
                                style={{ pointerEvents: "none" }}
                              >
                                <i className={
                                  status === "Cancelled"
                                    ? "fa-solid fa-circle-xmark"
                                    : status === "Pending"
                                    ? "fa-regular fa-clock"
                                    : "fa-solid fa-circle-check"
                                }></i>
                                &nbsp;{status}
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
              
              {reservationsData.length ? (
                <div className="rowperpage">
                  <div className="perpagecount">
                    Rows Per Page&nbsp;
                    <select onChange={handleReservationsPerPageChange} value={reservationsPerPage}>
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={150}>150</option>
                      <option value={200}>200</option>
                    </select>
                  </div>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={reservationsPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={reservationsPerPage}
                    onPageChange={handleReservationsPageChange}
                    containerClassName={"pagination custom-pagination"}
                    activeClassName={"active"}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

